import { GET_STATISTICS_SUCCESSFUL, GET_USER_STATS_SUCCESS } from 'redux/actions/Dashboard';

const initialState = {
  statistics: [],
  user_stats: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_STATISTICS_SUCCESSFUL:
      return { ...state, statistics: action.payload.data };
    case GET_USER_STATS_SUCCESS:
      return { ...state, locations: action.payload.data };
    default:
      return state;
  }
};
